import useSubscriptions from "@/queries/use_subscriptions.ts";
import EmptyState from "@components/empty_state.tsx";
import Fingerprint6 from "@images/fingerprint_6.svg";
import useTranslation from "@hooks/use_translation.ts";
import { JobAlertsCard } from "@components/job_alerts/card.tsx";
import "./grid.scss";

type Props = {
  onEditWhilePaused?: (editPath: string, companyName: string) => void;
  modal?: boolean;
};

export const JobAlertsGrid = ({ onEditWhilePaused, modal }: Props) => {
  const { t } = useTranslation("jobAlerts");
  const {
    data: { subscriptions },
  } = useSubscriptions();

  if (subscriptions.length === 0) {
    return (
      <EmptyState
        svg={Fingerprint6}
        title={t("noJobAlertsYet")}
        message={t("createAnAlert")}
        padding="60px"
      />
    );
  }

  return (
    <div className="job-alerts-grid">
      {subscriptions.map((subscription) => (
        <JobAlertsCard
          key={subscription.editPath}
          subscription={subscription}
          onEditWhilePaused={onEditWhilePaused}
          modal={modal}
        />
      ))}
    </div>
  );
};
